import { ButtonTableHeader } from '@/components/new/table/header/components/ButtonTableHeader'
import { DropdownTableHeader } from '@/components/new/table/header/components/DropdownTableHeader'
import { HeaderActionButton } from '@/components/new/table/header/HeaderActions'
import { TextTableHeader } from '@/components/new/table/header/components/TextTableHeader'

export const HeaderElement = ({
  headerActionButton,
}: {
  headerActionButton: HeaderActionButton
}) => {
  switch (headerActionButton.type) {
    case 'button':
      return (
        <ButtonTableHeader
          icon={headerActionButton.icon}
          label={headerActionButton.label}
          onClick={headerActionButton.onClick}
        />
      )
    case 'dropdown':
      return (
        <DropdownTableHeader
          label={headerActionButton.label}
          options={headerActionButton.options}
        />
      )
    case 'text':
      return <TextTableHeader label={headerActionButton.label} />
  }
}
